import { Component } from '@angular/core';

@Component({
    selector: 'app-footer',
    template: `
    <div class="layout-footer clearfix">
        <span class="footer-text-left">Royal Systems - Enterprise Business Solutions</span>
        <div class="layout-footer-icons">
            <i class="fa fa-copyright" aria-hidden="true"></i>
            <span>2017</span>
        </div>
    </div>
    `
})
export class AppFooterComponent { }
